import { EthersContractWrapper } from "./contract";
const abi = ["function balanceOf(address owner) view returns (uint256)"];
export default class ERC20Token extends EthersContractWrapper {
    constructor(runner, address) {
        super({
            address,
            runner,
        }, {
            address,
            abi,
        });
    }
    async balanceOf(owner) {
        return (await this.instance.balanceOf(`0x${owner.identifierHex}`));
    }
}
//# sourceMappingURL=erc20-token.js.map